import * as ToastPrimitive from '@radix-ui/react-toast'

const ToastAction = ToastPrimitive.Action

export { ToastAction }
